// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"BC8nw","rc-tabs-tab-active":"J5JYm","input-suffix":"Vr1IR","nav-item":"I7yC7","navContainer":"FHP6r","container":"n87UR","nav":"-d6ex","content":"_8WTN5"};